"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Label_1 = require("./Form/Label");
const Icon_1 = require("./Icon");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const CHECKBOX_STYLES = {
    blue: {
        checkedBackgroundColor: constants_1.Color.BLUE,
        checkedIconColor: constants_1.Color.WHITE,
    },
    'light-blue': {
        checkedBackgroundColor: constants_1.Color.LIGHTER_BLUE,
        checkedIconColor: constants_1.Color.BLUE,
    },
    inverted: {
        checkedBackgroundColor: constants_1.Color.WHITE,
        checkedIconColor: constants_1.Color.BLUE,
        border: constants_1.theme.border.style.thinDark,
    },
};
const DEFAULT_CHECKBOX_COLOR = 'blue';
const SIZES = {
    sm: 16,
    md: 20,
};
const getSize = (size) => SIZES[size ?? 'md'];
const CheckboxIcon = (0, styled_1.default)(Icon_1.Icon)((props) => {
    const style = CHECKBOX_STYLES[props.variant ?? DEFAULT_CHECKBOX_COLOR];
    return {
        bottom: 0,
        color: props.indeterminate ? constants_1.Color.LIGHT_BLUE : style.checkedIconColor,
        left: 0,
        margin: 'auto',
        opacity: 0,
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        top: 0,
        transform: 'scale(0.8)',
        transition: `opacity ${constants_1.theme.animation.transition}, transform ${constants_1.theme.animation.transition}`,
        zIndex: 1,
        '@media (prefers-reduced-motion)': {
            transitionDuration: '0ms',
        },
    };
});
const CheckboxInput = styled_1.default.input((props) => {
    const size = getSize(props.checkboxSize);
    const style = CHECKBOX_STYLES[props.variant ?? DEFAULT_CHECKBOX_COLOR];
    return {
        appearance: 'none',
        backgroundColor: constants_1.Color.WHITE,
        border: style.border ?? `1px solid ${constants_1.theme.color.border}`,
        borderRadius: props.checkboxSize === 'sm'
            ? constants_1.theme.border.radius.small
            : constants_1.theme.border.radius.normal,
        cursor: 'pointer',
        display: 'block',
        flexShrink: 0,
        height: size,
        margin: 0,
        padding: 0,
        transition: `border-color ${constants_1.theme.animation.transition}, background-color ${constants_1.theme.animation.transition}`,
        width: size,
        '&:checked': {
            backgroundColor: props.indeterminate
                ? constants_1.Color.LIGHTEST_BLUE
                : style.checkedBackgroundColor,
            borderColor: style?.border ??
                (props.indeterminate
                    ? constants_1.Color.TRANSPARENT_BLUE
                    : style.checkedBackgroundColor),
            '& + *': {
                opacity: 1,
                transform: 'scale(1)',
            },
        },
        '&:disabled': {
            backgroundColor: constants_1.Color.DARK_MEDIUM_GREY,
            borderColor: constants_1.Color.DARK_MEDIUM_GREY,
            cursor: 'not-allowed',
            '& + *': {
                color: constants_1.Color.DARKEST_MEDIUM_GREY,
            },
        },
    };
});
const CheckboxRoot = styled_1.default.div((props) => {
    const size = getSize(props.checkboxSize);
    return {
        alignItems: 'center',
        gridGap: 8,
        height: size,
        position: 'relative',
        width: size,
        ...(0, utils_1.createStyles)(props.styles),
    };
});
const Checkbox = (props) => {
    const input = ((0, jsx_runtime_1.jsxs)(CheckboxRoot, { checkboxSize: props.size, styles: props.label ? undefined : props.styles, children: [(0, jsx_runtime_1.jsx)(CheckboxInput, { checkboxSize: props.size, checked: props.checked, disabled: props.disabled, indeterminate: props.indeterminate, onChange: (event) => props.onChange?.(event.target.checked), type: "checkbox", variant: props.variant }), (0, jsx_runtime_1.jsx)(CheckboxIcon, { indeterminate: props.indeterminate, name: props.indeterminate ? 'MinusSmIcon' : 'CheckIcon', size: props.size, variant: props.variant })] }));
    return props.label ? ((0, jsx_runtime_1.jsx)(Label_1.Label, { color: props.labelColor, cursor: props.disabled ? 'not-allowed' : 'pointer', placement: props.labelPlacement ?? 'right', size: props.size, styles: props.styles, text: props.label, children: input })) : (input);
};
exports.Checkbox = Checkbox;
